import { render, staticRenderFns } from "./CoozzyConfidentialIcon.vue?vue&type=template&id=6385cbef&scoped=true"
import script from "./CoozzyConfidentialIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyConfidentialIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyConfidentialIcon.vue?vue&type=style&index=0&id=6385cbef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385cbef",
  null
  
)

export default component.exports